export default "__VITE_ASSET__CMmUqSva__"